import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import sha256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';

import DefaultLoader from '../../../shared/default-loader/components/default-loader';
import PageHeader from '../../../shared/page-header/components/page-header';
import { getUserProfile, changePassword } from '../actions/user-profile-actions';
import ResetPasswordForm from '../../reset-password/components/reset-password-form';
import RenderIf from '../../../shared/render-if/components/render-if';
import resetPasswordsConstants from '../../reset-password/constants/reset-password-constants';
import constants from '../../../../common/constants';

class UserProfile extends Component {
  componentDidMount() {
    const { getUserProfile, profile } = this.props;

    if (!profile) {
      getUserProfile();
    }
  }

  handleChangePasswordFormSubmit(values) {
    const { profile, changePassword } = this.props;

    if (!values[resetPasswordsConstants.fields.old_password]) {
      throw new SubmissionError({ old_password: 'CHANGE_PASSWORD.OLD_PASSWORD_REQUIRED', _error: `Old password failed!` });
    }

    const newPassword = sha256(constants.magic_salt + values[resetPasswordsConstants.fields.password]).toString(Base64);
    const oldPassword = sha256(constants.magic_salt + values[resetPasswordsConstants.fields.old_password]).toString(Base64);

    changePassword(profile.email, oldPassword, newPassword);
  }

  render() {
    const { profile } = this.props;

    return (
      <div className="p-t-20">
        <PageHeader title={'CHANGE_PASSWORD.SUBMIT_BTN'} />
        <RenderIf if={profile}>
          <div className="row display-flex-center">
            <div className="col-md-6 col-sm-12">
              <ResetPasswordForm btnText={'CHANGE_PASSWORD.SUBMIT_BTN'} handleFormSubmit={this.handleChangePasswordFormSubmit.bind(this)} isChangePasswordForm={true} />
            </div>
          </div>
        </RenderIf>
        <RenderIf if={!profile}>
          <DefaultLoader />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
});

const mapDispatchToProps = dispatch => ({
  getUserProfile: () => {
    dispatch(getUserProfile());
  },
  changePassword: (email, oldPassword, newPassword) => {
    dispatch(changePassword(email, oldPassword, newPassword));
  },
});

UserProfile.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/app/main/user-profile/components/change-password.js